import { ProgressionBar } from '@pelckmans/business-components/components/progression-bar';
import { useTranslation } from 'react-i18next';

type ProgressionAndResultBarProps = {
  achievable: number;
  achieved: number;
  maximum: number;
  isPending?: boolean;
};

export default function ProgressBar({
  achievable,
  achieved,
  maximum,
  isPending,
}: ProgressionAndResultBarProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <ProgressionBar
      achievable={achievable}
      achieved={achieved}
      maximum={maximum}
      pending={isPending ? maximum : 0}
      translations={isPending ? { pending: t('BUSINESS_COMPONENTS.PROGRESSION_BAR.PENDING') } : undefined}
    />
  );
}
